import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserDataService } from '../app/services/user/userData.service';

@Injectable()
export class SharedVals {
  public role = new BehaviorSubject<string>('');
  public roleval = new BehaviorSubject<any>('');
  public loginId = new BehaviorSubject<any>('');
  public refreshData: boolean = false;
  load;

  roleData = this.role.asObservable();
  roleValData = this.roleval.asObservable();
  loginIdData = this.loginId.asObservable();

  constructor(public userService: UserDataService) {
    if (localStorage.getItem('Token')) {
      //this.userService.userData$.subscribe(res => {
        if (localStorage.RoleVal)
          this.setRoleVal(localStorage.RoleVal);
        else
          this.setRoleVal('');

        if (localStorage.Role)
          this.setRole(localStorage.Role);
        else
          this.setRole('');

        if (localStorage.userId)
          this.setLoginId(localStorage.userId);
        else
          this.setLoginId('');
      // }, err => {
      
      //   this.setRoleVal('');
      //   this.setRole('');
      //   this.setLoginId('');
      // });
    }
  }

  setRole(values: string) {
    this.role.next(values);
  }

  setRoleVal(values: any) {
    this.roleval.next(values);
  }

  setLoginId(values: any) {
    this.loginId.next(values);
  }  
}



// WEBPACK FOOTER //
// ./src/shared/SharedVals.ts